module.exports = __webpack_public_path__ + "img/wait.a621cd1d.gif";